<template lang="pug">
  div(v-if="banner")
    portal(to="pageTitle")
      span Редактировать баннер

    v-container
      Settings(
        :dateStart="dateStart?(new Date(dateStart)):null",
        :dateEnd="dateEnd?(new Date(dateEnd)):null",
        :active="active",
        :countriesExcluded="countriesExcluded"
        :countriesIncluded="countriesIncluded"
        :sitesExcluded="sitesExcluded"
        :sitesIncluded="sitesIncluded"
        :languages="languages"
        :locale="locale"

        @dateStartChanged="onDateStartChanged"
        @dateEndChanged="onDateEndChanged"
        @activeChanged="onActiveChanged"
        @countriesExcludedChanged="onCountriesExcludedChanged"
        @countriesIncludedChanged="onCountriesIncludedChanged"
        @sitesExcludedChanged="onSitesExcludedChanged"
        @sitesIncludedChanged="onSitesIncludedChanged"
        @languageChanged="onLanguageChanged"
      )

      .mt-10

      Content(
        :name="name"
        :text="text"
        :link="link"
        :delImage="delImage"
        :image="getLocalValue(image)"
        @nameChanged="onNameChanged"
        @textChanged="onTextChanged"
        @linkChanged="onLinkChanged"
        @imageChanged="onImageChanged"
        @delImageChanged="onDelImageChanged"
      )

      .mt-10

      Controls(
        hasDelete
        @save="onSave"
        @delete="onDelete"
      )
</template>

<script>
import Controls from '../../components/widgets/PostControls'
import notify from '../../mixins/notify'

import Settings from './components/Settings'
import Content from './components/Content'
import Mixin from './components/Mixin.js'

import BannerGQL from '../../graphql/private/Banner/Banner.gql'
import UpdateBannerGQL from '../../graphql/private/Banner/UpdateBanner.gql'
import RemoveBannerGQL from '../../graphql/private/Banner/RemoveBanner.gql'

export default {
  name: 'banners__id',
  components: {
    Settings,
    Content,
    Controls,
  },
  mixins: [Mixin, notify],
  data() {
    return {
      routeId: this.$route.params.id,
    }
  },

  apollo: {
    banner: {
      query: BannerGQL,
      variables() {
        return {
          query: {
            locale: this.locale,
            id: this.routeId,
          },
        }
      },
    },
  },

  methods: {
    getTime(tin) {
      if (!tin) {
        return null
      }

      return new Date(tin).toISOString()
    },
    async onSave() {
      const dayStart = this.getTime(this.dateStart)
      const dayEnd = this.getTime(this.dateEnd)

      try {
        if (this.delImage) {
          this.imageFile = null
        }

        await this.$apollo.mutate({
          mutation: UpdateBannerGQL,
          variables: {
            input: {
              id: this.routeId,
              active: this.active,
              countriesExcluded: this.countriesExcluded,
              countriesIncluded: this.countriesIncluded,
              sitesExcluded: this.sitesExcluded,
              sitesIncluded: this.sitesIncluded,
              dateStart: dayStart,
              dateEnd: dayEnd,
              image: this.imageFile,
              delImage: this.delImage,
              link: this.link,
              locale: this.locale,
              name: this.name,
              text: this.text,
            },
          },
        })

        await this.$apollo.queries.banner.refetch()
        this.imageFile = null
        this.delImage = false

        this.notify({
          text: 'Баннер обновлен!',
        })
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
    },

    async onDelete() {
      try {
        await this.$apollo.mutate({
          mutation: RemoveBannerGQL,
          variables: {
            id: this.routeId,
          },
        })

        this.notify({
          text: 'Баннер удален!',
        })
        await this.$apollo.queries.banner.refetch()
      } catch (err) {
        this.notify({
          text: err.message,
          type: 'error',
        })
        throw new Error(err)
      }
      await this.$router.push({
        name: 'banners__list',
      })
    },
  },

  watch: {
    banner(banner) {
      if (!banner) {
        this.$router.push({
          name: 'banners__list',
        })
      }
      const pst = {
        ...banner,
        dateStart: banner && this.banner.dateStart ? this.banner.dateStart : null,
        dateEnd: banner && this.banner.dateEnd ? this.banner.dateEnd : null,
      }
      for (const field in pst) {
        if (field === 'name' || field === 'text' || field === 'link') {
          this[field] = this.getLocalValue(pst[field])
        } else {
          this[field] = pst[field]
        }
      }
      this.files = this.attachments
    },
  },
}
</script>
